import {Pipe, PipeTransform} from "@angular/core";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {nil} from "../typer/nullish";
import {formaterFilstørrelse} from "felles-ng2/støttefunksjoner/filer";

@Pipe({name: 'filstoerrelse', pure: true, standalone: true})
export class FormaterFilstørrelsePipe implements PipeTransform {
    constructor() {}

    transform(value: number|nil): string | null {
        return erIkkeNil(value) ? formaterFilstørrelse(value) : '';
    }
}
